import {
  Box,
  Flex,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text
} from '@chakra-ui/react';
import { Button, Icon, IconName } from '../../atoms';
import { Select, SelectOptionsType } from '../select/select';
import {
  TagMultiSelect,
  TagMultiSelectOptionType
} from '../tag-multi-select/tag-multi-select';

type Props = {
  selectOptions: SelectOptionsType;
  selectValue: string;
  multiSelectOptions: TagMultiSelectOptionType[];
  multiSelectValues: string[];
  handleApplyButtonClick: (
    multiSelectValues: string[],
    selectValue: string
  ) => void;
  allOptionsLabel: string;
  allValuesLabel: string;
  noValuesLabel: string;
  middleTextLabel: string;
  applyButtonLabel: string;
  clearButtonLabel: string;
  label: string;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onMultiSelectChooseAll: () => void;
  onMultiSelectChooseNone: () => void;
  onMultiSelectChooseOne: (value: string) => void;
  onSelectChange: (value: string) => void;
};

export function AssertionFilter({
  selectOptions,
  selectValue,
  multiSelectOptions,
  multiSelectValues,
  allOptionsLabel,
  allValuesLabel,
  middleTextLabel,
  noValuesLabel,
  applyButtonLabel,
  clearButtonLabel,
  label,
  isOpen,
  onOpen,
  onClose,
  handleApplyButtonClick,
  onMultiSelectChooseAll,
  onMultiSelectChooseOne,
  onMultiSelectChooseNone,
  onSelectChange
}: Props): JSX.Element {
  return (
    <Popover closeOnBlur={true} isOpen={isOpen} onClose={onClose}>
      <PopoverTrigger>
        <Box
          ml={'space_unit.x2'}
          cursor={'pointer'}
          data-testid="assertionFilterLabel"
        >
          <Flex align={'center'} onClick={isOpen ? onClose : onOpen}>
            <Text>
              {label}
              {multiSelectValues.length > 0 && (
                <span>
                  ({multiSelectValues.length}) - {selectValue}
                </span>
              )}
            </Text>
            <Icon height={'.5rem'} name={IconName.ArrowDown} />
          </Flex>
        </Box>
      </PopoverTrigger>
      <PopoverContent w="500px">
        <PopoverBody mt={'space_unit.x2'}>
          <Flex align={'center'}>
            <TagMultiSelect
              options={multiSelectOptions}
              selectedValues={multiSelectValues}
              allOptionsLabel={allOptionsLabel}
              allValuesLabel={allValuesLabel}
              noValuesLabel={noValuesLabel}
              onChangeAll={onMultiSelectChooseAll}
              onChangeItems={onMultiSelectChooseOne}
            />
            <Text fontWeight={'bold'} ml={'space_unit.x1'} mr={'space_unit.x1'}>
              {middleTextLabel}
            </Text>
            <Select
              options={selectOptions}
              defaultValue={selectOptions[0].value}
              value={selectValue}
              onChange={(value) => onSelectChange(value as string)}
            ></Select>
          </Flex>
          <Button
            mt={'space_unit.x2'}
            onClick={() => {
              onClose();
              handleApplyButtonClick(multiSelectValues, selectValue);
            }}
          >
            {applyButtonLabel}
          </Button>
          <Button
            variant={'secondary'}
            ml={'space_unit.x1'}
            mt={'space_unit.x2'}
            onClick={() => {
              onClose();
              onMultiSelectChooseNone();
              onSelectChange(selectOptions[0].value as string);
            }}
          >
            {clearButtonLabel}
          </Button>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
